export default __webpack_public_path__ + "static/media/blue-close-icon.d0af2da1.svg";